let region_text_options = {
  draw: "text",
  avoid: true,
  size: 36,
  font: "36px Arial",
  zIndex: 5,
  fillStyle: "black",
  shadowBlur: 10,
  fontColorRange: []
};

let text_options_high = {
  textKey: "countText",
  draw: "text",
  // avoid: true,
  fillStyle: "white",
  shadowBlur: 10,
  zIndex: 5,
  size: 12,
  font: "1.5vh Arial",
  fontColorRange: []
};

let text_options_name = {
  draw: "text",
  fillStyle: "#d0d0d0",
  avoid: true,
  size: 12,
  font: "1.5vh Arial",
  shadowBlur: 10,
  offset: {
    // 文本便宜值
    x: 0,
    y: -25
  }
};

let region_options_name = {
  draw: "text",
  font: "36px Arial",
  fillStyle: "#d0d0d0",
  shadowBlur: 10
};

let grid_options_name = {
  draw: "text",
  font: "36px Arial",
  fillStyle: "#d0d0d0",
  shadowBlur: 10,
  zIndex: 5000,
  fontColorRange: []
};

let options_bubble = {
  fillStyle: "rgba(255, 50, 50, 0.6)",
  maxSize: 20,
  max: 30,
  draw: "bubble",
  zIndex: 4
};

var options_circle = {
  zIndex: 4,
  fillStyle: "rgba(255, 50, 50, 0)",
  strokeStyle: "white",
  lineWidth: 2,
  globalCompositeOperation: "lighter",
  size: 5,
  draw: "simple"
};
export {
  text_options_high,
  text_options_name,
  region_text_options,
  options_bubble,
  options_circle,
  grid_options_name,
  region_options_name
};
